module.exports = __webpack_public_path__ + "img/build-page.aeda7f78.png";